import { Features } from "@/components/landing/features";
import { Hero } from "@/components/landing/hero";

export function Landing() {
  return (
    <>
      <Hero />
      <Features />
    </>
  );
}

